import dispatcher from '../dispatcher';
import constants from '../constants';

import * as LocationService from '../services/LocationService';

export function getByGeometry(geometry) {
    dispatcher.dispatch({
        type: constants.LOCATIONS_GET
    });

    LocationService.getByGeometry(geometry);
}

export function receiveByGeometry(searchResults){
    dispatcher.dispatch({
        type: constants.LOCATIONS_GET_RESPONSE,
        searchResults
    });
}

export function setSelectedSearchResult(searchResultId) {
    dispatcher.dispatch({
        type: constants.LOCATIONS_SELECTED_SET,
        searchResultId
    });
}